export type RealtimeContainerType = 'ISSUE' | 'PROJECT';
export const APP_ID_PREFIX = 'polaris-';
